import { render, staticRenderFns } from "./component.vue?vue&type=template&id=4cb29258&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb29258",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cb29258')) {
      api.createRecord('4cb29258', component.options)
    } else {
      api.reload('4cb29258', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=4cb29258&scoped=true&", function () {
      api.rerender('4cb29258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/loading-icon/component.vue"
export default component.exports